<template>
	<div
		v-if="filteredSessionList.length > 0"
		class="session-list"
	>
		<component
			:is="getComponentType(item)"
			v-for="item in filteredSessionList"
			:key="item.session_id"
			:session="item"
			@stop="deleteSession"
		/>
	</div>
</template>

<script>
import RecordItem from "item/Record";
import RtmpItem from "item/Rtmp";
import StreamItem from "item/Stream";
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";

export default {
	name: "SessionList",
	components: {
		RecordItem,
		RtmpItem,
		StreamItem
	},
	props: {
		recorder: {
			type: Object,
			required: true
		},
		sessionList: {
			type: Array,
			required: true
		}
	},
	computed: {
		filteredSessionList() {
			return this.sessionList.filter((session) => !session._deleted && !session._hidden);
		}
	},
	methods: {
		deleteSession(session) {
			session._deleted = true;

			http.delete(`${location.protocol}//${this.recorder.server.hostname}/api/v2/recorder/${this.recorder.recorder_id}/session/${session.session_id}`)
			.then(() => {
				$bus.$emit("_App.getSessionStatus");
			})
			.catch((error) => {
				session._deleted = false;
				alert.error("Unable to stop recording session", error.response);
			});
		},
		getComponentType(item) {
			if (item.type === "rtmp")
				return "RtmpItem";
			else if (item.stream_id)
				return "StreamItem";

			return "RecordItem";
		}
	}
};
</script>

<style lang="scss" scoped>
.session-list {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
	grid-gap: 16px;
	margin-top: 15px;
	justify-items: center;
	.session-list-item {
		align-self: start;
		width: 100%;
	}
}

// IE11 specific, using flex due to poor grid support
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.session-list {
		display: flex;
		flex-wrap: wrap;
	}
}
</style>
